





















import Vue from 'vue';
import MStoreCardPanel from '@/components/shared/MStoreCardPanel.vue';
import MStoreDashboardButton from '@/components/shared/MStoreDashboardButton.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { MStoreDashboardButtonModel } from '@/types';

export default Vue.extend({
  name: 'MStoreQuickActions',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    dashboardButtons: {
      type: Array as () => MStoreDashboardButtonModel[],
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    MStoreCardPanel,
    MStoreDashboardButton,
    LoadingSpinner
  }
});
